export default __webpack_public_path__ + "static/media/student.74491b81.png";